import { sliderAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

import { focusRing } from "theme/tokens/accessibility";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(sliderAnatomy.keys);

const baseStyleContainer = defineStyle({
  _disabled: {
    opacity: 1,
  },
});

const baseStyleTrack = defineStyle({
  borderRadius: "full",
  bg: "highlight.emphasized",

  // the three lines below are needed to avoid the glitch with the sub-pixel rendering
  position: "relative !important",
  top: "0 !important",
  transform: "initial !important",
  _disabled: {
    bg: "neutral.subtle",
  },
});

const baseStyleThumb = defineStyle({
  borderRadius: "full",
  bg: "bg.container",
  border: "4px solid",
  borderColor: "highlight.solid",
  _focus: {
    boxShadow: "none",
  },
  _focusVisible: {
    ...focusRing,
  },
  _disabled: {
    bg: "neutral.subtle",
    borderColor: "border.emphasized",
  },
});

const baseStyleFilledTrack = defineStyle({
  bg: "highlight.solid",

  // the three lines below are needed to avoid the glitch with the sub-pixel rendering
  position: "relative !important",
  top: "0 !important",
  transform: "initial !important",

  _disabled: {
    bg: "neutral.emphasized",
  },
});

const baseStyle = definePartsStyle({
  container: baseStyleContainer,
  track: baseStyleTrack,
  thumb: baseStyleThumb,
  filledTrack: baseStyleFilledTrack,
});

const rangeStyleTrack = defineStyle({
  h: "3",
  bg: "highlight.emphasized",
  _disabled: {
    bg: "neutral.subtle",
  },
});

const rangeStyleFilledTrack = defineStyle({
  bg: "highlight.muted",

  _disabled: {
    bg: "neutral.emphasized",
  },
});

const rangeStyle = definePartsStyle({
  track: rangeStyleTrack,
  filledTrack: rangeStyleFilledTrack,
});

const sizeMd = definePartsStyle({
  thumb: { w: "4", h: "4", outline: "0px" },
  track: {
    h: "1",
  },
});

export const Slider = defineMultiStyleConfig({
  baseStyle,

  sizes: {
    md: sizeMd,
  },

  variants: {
    range: rangeStyle,
  },
});
